exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".round-image {\n  text-align: center; }\n  .round-image img {\n    border-radius: 50%;\n    height: 64px;\n    width: 64px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/data-list/data-grid2/data-grid2.component.scss
// module id = 1172
// module chunks = 4